import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

class HelpPopup extends React.Component {
  constructor (props) {
    super(props)

    this.popupElem = React.createRef()
    this.popupContent = React.createRef()
    this.getPopupTopPosition = this.getPopupTopPosition.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.hoverOut = this.hoverOut.bind(this)
    this.hoverOver = this.hoverOver.bind(this)

    this.state = {
      active: false
    }
  }

  hoverOver () {
    this.setState({ active: true })
    if (this.props.onHover) this.props.onHover()
  }

  hoverOut () {
    this.setState({ active: false })
  }

  handleClick (e) {
    e.stopPropagation()
    if (this.state.active) {
      this.hoverOut()
    } else {
      this.hoverOver()
    }
  }

  popupClashTop () {
    const navbar = document.querySelector('.js-navbar')
    return (
      (this.popupElem.current.getBoundingClientRect().top - navbar.clientHeight) <= this.popupContent.current.clientHeight
    )
  }

  getPopupTopPosition () {
    if (this.state.active) {
      if (this.popupClashTop()) {
        return -this.props.topOffset
      } else {
        return this.props.topOffset - this.popupContent.current.clientHeight
      }
    } else {
      return 0
    }
  }

  render () {
    let popupHover = classNames('HelpPopup', {
      'HelpPopup--active': this.state.active
    })

    let popupClass = classNames('HelpPopup__content', {
      'HelpPopup__content--active': this.state.active
    })

    let popupPosition = {
      top: this.getPopupTopPosition(),
      left: this.props.leftOffset ? this.props.leftOffset : 0,
      width: this.props.width ? `${this.props.width}px` : 'auto'
    }

    return (
      <div className={popupHover} ref={this.popupElem}>
        <div
          className='HelpPopup__trigger'
          onMouseEnter={this.hoverOver}
          onMouseLeave={this.hoverOut}
          onClick={this.handleClick}
        >
          {this.props.trigger}
        </div>
        <div
          className={popupClass}
          style={popupPosition}
          onTransitionEnd={() => {
            if (!this.state.active && this.props.onHover) this.props.offHover()
          }}
          ref={this.popupContent}
        >
          {this.props.children}
        </div>
      </div>
    )
  }
}

HelpPopup.defaultProps = {
  onHover: () => {},
  offHover: () => {}
}

HelpPopup.propTypes = {
  children: PropTypes.node,
  offHover: PropTypes.func,
  leftOffset: PropTypes.number,
  onHover: PropTypes.func,
  topOffset: PropTypes.number,
  trigger: PropTypes.node,
  width: PropTypes.number
}

export default HelpPopup
